var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37906 34.0013L4.57031 2.5H35.4328L32.6203 33.9963L19.9828 37.5L7.37906 34.0013Z",
    fill: "#E44F26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.8244L30.2125 31.9931L32.615 5.07812H20V34.8244Z",
    fill: "#F1662A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.7575H14.8875L14.535 12.8012H20V8.9375H19.9862H10.3125L10.405 9.975L11.3538 20.6212H20V16.7575Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0011 26.7922L19.9836 26.7972L15.6811 25.6359L15.4061 22.5547H13.3148H11.5273L12.0686 28.6197L19.9836 30.8172L20.0011 30.8122V26.7922Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9844 16.7578V20.6216H24.7419L24.2944 25.6328L19.9844 26.7953V30.8153L27.9056 28.6191L27.9631 27.9666L28.8706 17.7953L28.9656 16.7578H27.9244H19.9844Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9844 8.9375V11.3375V12.7925V12.8012H29.3044H29.3169L29.3944 11.9338L29.5706 9.975L29.6631 8.9375H19.9844Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.fd34ea4fcdaa2bcab9069b97838ee6d3.svg";
export { ForwardRef as ReactComponent };